/* global CVP */

module.exports = CVP.Log.getLogger('CVPAuth');
